import Axios, { InternalAxiosRequestConfig } from "axios";

const baseURL = process.env.API_URL;
if (!baseURL) {
	throw new Error("Base URL is not defined in environment variables");
}

export const api = Axios.create({
	baseURL: baseURL,
	headers: {
		"Content-Type": "application/json",
	},
	timeout: 5 * 60 * 1000,
});

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
	const token = localStorage.getItem("authToken");
	if (token) config.headers.Authorization = `Bearer ${token}`;
	return config;
});
api.interceptors.response.use((response) => response.data);
